import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./streets.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./streets.component.scss?ngResource";
import { ChangeDetectorRef, Component, NgZone, ViewChild } from "@angular/core";
import { TableSearchComponent } from "../../shared/components/table-search/table-search.component";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../app-controller.service";
import { ModuleConfigService } from "../../shared/services/module-config/module-config.service";
import { SaveSearchService } from "../../shared/services/save-search/save-search.service";
import { SearchTableService } from "../../shared/services/table-column-mapping/search-table.service";
import { MapServiceService } from "../../core/settings/shared/map-service.service";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import _ from "underscore";
import { SearchContainerHeight } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { StreetSearchEnum, StreetSearchOption } from "./shared/enums/street-search-enum";
import { StreetSearchService } from "./shared/services/street-search.service";
import { StreetHeadingEnumHeadingLookup, StreetsConstants } from "./streets.constants";
import { ArcGisStreetColumn } from "./shared/models/arcgis-street-column.model";
import { StreetSearchColumnToArcGisColumnStreetsLookup } from "./shared/models/street-search-to-arcgis.model";
import { AlertType } from "../../shared/models/alert";
import { Store } from "@ngrx/store";
import { PropertiesConstants } from "../properties/properties.constants";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { streetsSearch } from "../../store/actions/tab-streets.actions";
let StreetsComponent = class StreetsComponent {
    appControllerService;
    streetsSearchService;
    moduleConfigService;
    changeDetectorRef;
    saveSearchService;
    searchTableService;
    mapService;
    zone;
    requestStatusService;
    store;
    tableSearchFilterComponent;
    pageHeading = StreetsConstants.Headings.PageHeadings;
    showSearchButton = true;
    StreetAttributeToTableColumn;
    filterOptions;
    selectedStreetSubject = new BehaviorSubject(undefined);
    selectedStreet;
    placeHolder;
    searchPlaceHolder;
    streetSearchTableDataSource;
    isMapLoaded = false;
    parentComponentRef = "streetsComponent";
    preSelected;
    mapComponent;
    streetsList = [];
    setMapLayerSubscription;
    listenForSearchChangesSubscription;
    mapLocationAsObservableSubscription;
    constructor(appControllerService, streetsSearchService, moduleConfigService, changeDetectorRef, saveSearchService, searchTableService, mapService, zone, requestStatusService, store) {
        this.appControllerService = appControllerService;
        this.streetsSearchService = streetsSearchService;
        this.moduleConfigService = moduleConfigService;
        this.changeDetectorRef = changeDetectorRef;
        this.saveSearchService = saveSearchService;
        this.searchTableService = searchTableService;
        this.mapService = mapService;
        this.zone = zone;
        this.requestStatusService = requestStatusService;
        this.store = store;
        this.initializeColumnToObjectMapping();
    }
    ngOnInit() {
        this.initializeConstants();
        this.finaliseMapSettings();
    }
    setMapLayer() {
        this.setMapLayerSubscription = this.mapService.layerUrlListAsObservable.subscribe((layers) => {
            if (layers) {
                this.streetsSearchService.clearURLList();
                layers.forEach((layer) => {
                    if (layer.moduleId === Number(this.appControllerService.selectedModuleID))
                        this.streetsSearchService.setURL(layer.layerType, layer.url);
                });
                this.setStreetSearchOptions();
            }
        });
    }
    handleAdvancedSearch() {
    }
    setHeadings() {
        switch (this.streetsSearchService.streetSearchType) {
            case StreetSearchOption.Street:
                this.StreetAttributeToTableColumn = StreetHeadingEnumHeadingLookup;
                break;
        }
        this.streetsSearchService.setTableColumnMap(this.StreetAttributeToTableColumn);
        this.setFilterOptions();
        this.changeDetectorRef.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
    }
    StreetSelected($event) {
        this.selectedStreetSubject.next($event);
    }
    async handleSimpleSearch(search) {
        await this.searchStreet(search);
    }
    async doStreetSearch(url, searchText, column) {
        this.requestStatusService.showBusySpinner(SharedConstants.STREET_SEARCH_STATUS);
        try {
            // @ts-ignore
            await this.streetsSearchService.doSearch(url, searchText, column, false)
                .then((streetsFound) => {
                if (streetsFound.length > 0) {
                    this.streetsSearchService.addMapLocatorLinks(streetsFound);
                    // this.changeDetectorRef.detectChanges();
                }
                else {
                    this.streetsList = [];
                    this.streetsSearchService.clearStreetsList();
                    this.appControllerService.showMessage(`${SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE} that matches your search term`, AlertType.Warning);
                }
                this.requestStatusService.removeBusySpinner(SharedConstants.STREET_SEARCH_STATUS);
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner(SharedConstants.STREET_SEARCH_STATUS);
        }
    }
    ngAfterViewInit() {
        this.listenForSelectedStreetChange();
        this.listenForSearchChanges();
    }
    finaliseMapSettings() {
        this.searchPlaceHolder = `${SharedConstants.SEARCH_PREFIX} ${this.pageHeading.toLocaleLowerCase()}`;
        this.setMapLayer();
        this.showMap(false);
    }
    setFilterOptions() {
        this.filterOptions = new Array();
        this.filterOptions.push(SharedConstants.FILTER_BY_DEFAULT);
        this.filterOptions.push(..._.values(this.StreetAttributeToTableColumn.values()));
        this.changeDetectorRef.detectChanges();
    }
    initializeColumnToObjectMapping() {
        this.StreetAttributeToTableColumn = StreetHeadingEnumHeadingLookup;
    }
    setStreetSearchOptions() {
        const searchOptionList = [];
        if (this.moduleConfigService.isStreetNamingModule() && this.streetsSearchService.streetUrl && this.streetsSearchService.streetUrl !== "") {
            searchOptionList.push(..._.values(StreetSearchEnum));
        }
        const streetOptions = [];
        searchOptionList.forEach((option) => {
            if (streetOptions.indexOf(option) < 0) {
                streetOptions.push(option);
            }
        });
        this.searchTableService.setPropertySearchOptions(streetOptions);
        this.streetsSearchService.setSearchOptionLookup(StreetSearchEnum);
        this.preSelected = StreetSearchEnum.Name;
        this.streetsSearchService.setSelectedSearchOption(this.preSelected);
        this.searchTableService.setPreSelectedSearchOption(this.preSelected);
        this.selectedStreet = this.selectedStreetSubject.asObservable();
        this.setHeadings();
    }
    showMap(displayMap) {
        if (displayMap) {
            this.isMapLoaded = true;
        }
        else {
            this.isMapLoaded = false;
        }
    }
    async searchStreet(search) {
        if (search.column !== SharedConstants.SEARCH_BY_DEFAULT) {
            // @ts-ignore
            const column = this.getArcGISColumn(search.column);
            const url = this.streetsSearchService.getLayerUrl(this.streetsSearchService.streetSearchType);
            // @ts-ignore
            this.streetSearchTableDataSource = await this.doStreetSearch(url, search.text, column);
            this.store.dispatch(streetsSearch({ value: this.streetSearchTableDataSource }));
            this.changeDetectorRef.detectChanges();
        }
    }
    getArcGISColumn(column) {
        this.streetsSearchService.setSelectedSearchOption(column);
        this.setHeadings();
        switch (this.streetsSearchService.streetSearchType) {
            case StreetSearchOption.Street:
                return StreetSearchColumnToArcGisColumnStreetsLookup.get(column);
        }
    }
    initializeConstants() {
        this.initializePageHeader();
        this.initializeSearchTableConstants();
        this.streetsSearchService.clearStreetsList();
        this.streetsSearchService.clearTableColumnMap();
        this.streetsSearchService.setTableColumnMap(StreetHeadingEnumHeadingLookup);
    }
    initializePageHeader() {
        this.pageHeading = StreetsConstants.Headings.PageHeadings;
    }
    initializeSearchTableConstants() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.streetsList = [];
        this.streetsSearchService.clearStreetsList();
        this.streetSearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.searchTableService.changeContainerHeight(SearchContainerHeight.Streets);
        this.StreetAttributeToTableColumn = StreetHeadingEnumHeadingLookup;
    }
    ngOnDestroy() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.streetsList = [];
        this.streetsSearchService.clearStreetsList();
        this.streetSearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.changeDetectorRef.detectChanges();
    }
    listenForSelectedStreetChange() {
        this.mapLocationAsObservableSubscription = this.streetsSearchService.mapLocationAsObservable.subscribe((selectedStreetId) => {
            if (selectedStreetId && selectedStreetId !== "") {
                this.viewSelectedPropertyOnMap(selectedStreetId);
            }
        });
    }
    listenForSearchChanges() {
        this.listenForSearchChangesSubscription = this.streetsSearchService.streetListAsObservable.subscribe((items) => {
            this.streetsList = items;
        });
    }
    viewSelectedPropertyOnMap(selectedStreetId) {
        try {
            const url = this.streetsSearchService.getLayerUrl(StreetSearchOption.Street);
            this.requestStatusService.showBusySpinner(SharedConstants.STREET_SEARCH_STATUS);
            // @ts-ignore
            this.streetsSearchService.doSearch(url, selectedStreetId, ArcGisStreetColumn.Id, true, StreetSearchOption.Street, true).then((result) => {
                if (result.length > 0) {
                    this.setMapRoute(result);
                }
                this.requestStatusService.removeBusySpinner(SharedConstants.STREET_SEARCH_STATUS);
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner(SharedConstants.STREET_SEARCH_STATUS);
        }
    }
    setMapRoute(streetsArray) {
        if (this.isMapLoaded) {
            this.showMap(true);
            this.mapComponent.removeGraphicsFromMap(PropertiesConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
            const geometries = [];
            streetsArray.forEach((street) => {
                geometries.push(street.geometry);
            });
            this.mapComponent.addGeometriesOnMap(geometries, PropertiesConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
            this.changeDetectorRef.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: StreetSearchService },
        { type: ModuleConfigService },
        { type: ChangeDetectorRef },
        { type: SaveSearchService },
        { type: SearchTableService },
        { type: MapServiceService },
        { type: NgZone },
        { type: RequestStatusService },
        { type: Store }
    ];
    static propDecorators = {
        tableSearchFilterComponent: [{ type: ViewChild, args: [TableSearchComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["streetsMap", { static: true },] }]
    };
};
StreetsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-streets",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], StreetsComponent);
export { StreetsComponent };
